
import React from "react";
import { Button } from "@/components/ui/button";
import { ArrowLeft, RefreshCw } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface PageHeaderProps {
  title: string;
  onRefresh: () => void;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, onRefresh }) => {
  const navigate = useNavigate();
  
  return (
    <div className="flex items-center gap-4 mb-6">
      <Button 
        variant="outline" 
        size="icon" 
        onClick={() => navigate("/")}
      >
        <ArrowLeft className="h-4 w-4" />
      </Button>
      <h1 className="text-2xl font-bold">{title}</h1>
      <Button 
        variant="outline" 
        size="sm" 
        onClick={onRefresh}
        className="ml-auto"
      >
        <RefreshCw className="h-4 w-4 mr-2" /> Refresh
      </Button>
    </div>
  );
};

export default PageHeader;
